(() => {
  if (window.DentalCanvasSubscriptionPurchaseLoaded) return;
  window.DentalCanvasSubscriptionPurchaseLoaded = true;

  const analyticsAllowed = () => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return typeof privacy?.analyticsProcessingAllowed !== 'function' || privacy.analyticsProcessingAllowed();
    } catch (_) {
      return true;
    }
  };

  const publish = (name, payload) => {
    if (!analyticsAllowed() || !window.Shopify?.analytics?.publish) return;
    Promise.resolve(window.Shopify.analytics.publish(name, payload)).catch(() => {});
  };

  const init = (picker) => {
    if (picker.dataset.initialized === 'true') return;
    picker.dataset.initialized = 'true';

    const productInfo = picker.closest('.product__info-container');
    const form = productInfo?.querySelector('product-form form');
    const submit = form?.querySelector('[type="submit"]');
    const submitText = submit?.querySelector('span');
    const price = picker.querySelector('[data-dc-selected-price]');
    const unitLabel = picker.querySelector('[data-dc-selected-unit]');
    const radios = [...picker.querySelectorAll('[data-dc-selling-plan]')];

    // The picker renders from a custom_liquid block where Dawn's
    // product_form_id variable is out of scope, so the radios arrive without a
    // usable form attribute. Associate them with the real product form here;
    // FormData(form) includes form-attribute-associated inputs, so the selected
    // selling_plan is submitted through Dawn's native add-to-cart request.
    // getAttribute is required: the form's variant <input name="id"> shadows
    // the HTMLFormElement id property, so form.id is that element, not the id.
    const formId = form?.getAttribute('id');
    if (formId) {
      radios.forEach((radio) => radio.setAttribute('form', formId));
    }

    const sync = (radio, source = 'init') => {
      if (!radio) return;

      radios.forEach((candidate) => {
        candidate.closest('.dc-subscription-plan')?.classList.toggle('is-selected', candidate === radio);
      });

      const unit = radio.dataset.planUnit || 'month';
      if (price) price.textContent = radio.dataset.planPrice || '';
      if (unitLabel) unitLabel.textContent = `/ ${unit}`;
      if (submitText) {
        const amount = radio.dataset.planPrice || '';
        submitText.textContent = amount ? `Start DentalCanvas — ${amount}/${unit}` : 'Start DentalCanvas';
      }

      if (source === 'change') {
        publish('dental_canvas:plan_selected', {
          product_id: picker.dataset.productId || '',
          selling_plan_id: radio.value,
          plan_name: radio.dataset.planName || '',
          price: radio.dataset.planPrice || '',
          page_path: window.location.pathname,
          placement: 'product_purchase'
        });
      }
    };

    radios.forEach((radio) => {
      radio.addEventListener('change', () => sync(radio, 'change'));
    });

    submit?.addEventListener('click', () => {
      const selected = radios.find((radio) => radio.checked);
      publish('dental_canvas:purchase_cta_clicked', {
        product_id: picker.dataset.productId || '',
        selling_plan_id: selected?.value || '',
        plan_name: selected?.dataset.planName || '',
        price: selected?.dataset.planPrice || '',
        page_path: window.location.pathname,
        placement: 'product_purchase'
      });
    });

    sync(radios.find((radio) => radio.checked) || radios[0]);
  };

  const boot = () => {
    document.querySelectorAll('[data-dc-subscription-picker]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
